/**
 * Checkout success handler
 * Clears cart and hides badge after successful payment
 */

import { Cart } from './cart.js'

;(function() {
  var container = document.getElementById('checkout-success');
  if (!container) return;

  if (Cart.isAvailable()) {
    Cart.clear();
  }

  var badge = document.getElementById('floating-cart-badge');
  if (badge) {
    badge.style.display = 'none';
  }
  var icon = document.getElementById('floating-cart-icon');
  if (icon) {
    icon.style.display = 'none';
  }
})();
